<template>
  <div>
    <div class="yyy" v-if="figureIndex == '1'">
      The pipeline for measuring and locating secondary structure variations by
      calculating the <i>Geometric Characteristics</i> among residues within
      studied proteins. (<i style="font-weight: bold">a</i>) preprocessing based
      on the structure preparation and representations. S-W & US-align
      algorithms were used to align two protein sequences (SA and SB),
      establishing the residue-level correspondences and ensuring a precise
      mapping promoting downstream analyses. (<i style="font-weight: bold">b</i
      >) computing <i>geometric characteristics</i> of studied amino acids. Key
      <i>geometric characteristics</i> of amino acids were calculated for both
      SA and SB, including: bend angles (KAPPA), dihedral angles (ALPHA),
      peptide backbone torsion angles (PHI and PSI), water exposed surface
      (ACC), etc. All characteristics were encoded into vectors (such as V1, V1’
      for SA and V2, V2’ for SB). (<i style="font-weight: bold">c</i>) depicting
      PLOT<span class="shangbiao">VSS</span> based on
      <i>geometric characteristics</i> among residues. Variations in secondary
      structure were located using PLOT<span class="shangbiao">VSS</span>. The
      darker the residue’s color was, the higher its ci value was, which
      reflected greater variation in its corresponding secondary structure.
      Moreover, the PLOT<span class="shangbiao">VSS</span> showed the type of
      secondary structure in SA and SB, with the classification information
      described in Supplementary Figure S23. (<i style="font-weight: bold">d</i
      >) calculating VSSmeasur based on the
      <i>Geometric Characteristics</i> among residues. VSSmeasur scores were
      calculated to quantify overall secondary structure variation.
      Particularly, the closer the VSSmeasur is to 1, the more different the
      secondary structures of two studied proteins are.
    </div>
    <div class="yyy" v-else-if="figureIndex == '2'">
      The pipeline for assessing structural segment shifts by calculating
      <i>Relative Distances</i> among residues within studied protein.
      <i style="font-weight: bold">a</i>&#41; preprocessing based on the
      structure preparation and representation. S-W and US-align algorithms were
      used to align two protein sequences (SA and SB), establishing the
      residue-level correspondence and facilitating the precise pairwise
      distance calculation for detecting segmental shifts.
      <i style="font-weight: bold">b</i>&#41; computing and normalizing the
      <i>Relative Distances</i> among amino acids. Pairwise distances between
      residues were computed for protein pairs after sequence alignment (such as
      dA1, dA2, dA3 for protein A and dB1, dB2, dB3 for protein B). Changes
      between these distances from two proteins were calculated and normalized
      based on weighting function using the maximum pairwise distances,
      resulting in SPS<span class="xiabiao">measur</span>.
      <i style="font-weight: bold">c</i>&#41; calculating SPS<span
        class="xiabiao"
        >measur</span
      >
      and generating PLOT<span class="shangbiao">SPS</span> based on relative
      distance. The PLOT<span class="shangbiao">SPS</span> depicted the protein
      segment shifts between two proteins. The vertical axis demonstrated the
      sequence of protein A (SA), and the horizontal axis provided the sequence
      of protein B (SB). The darker the color of residue pair was, the greater
      shift in its corresponding protein segment was. As shown, the area
      demarcated by the black dash line highlighted significant segment shift
      between domain 1 (colored in pink) and domain 2 (colored in blue),
      contrasting with minimal internal change within each domain.
    </div>
    <div class="yyy" v-else-if="figureIndex == '3'">
      Comparing the performances of <i>MELO</i> and avaiable methods in
      measuring structural variation. <i style="font-weight: bold">a</i>&#41;
      comparing the accuracies of two methods across four SCOP2 classification
      levels (Class, Fold/IUPR, Superfamily, and Family). <i>MELO</i> maintained
      a consistent accuracy &gt;99.7% at all levels, providing greater precision
      than TM-score in identifying the change at the level of superfamily and
      family (increased by about 5%). <i style="font-weight: bold">b</i>&#41;
      accuracy assessments between <i>MELO</i> and TM-score in identifying
      structural change induced by relatively small sequence alterations (the
      protein pairs with sequence identity &gt;70%). <i>MELO</i> kept consistent
      accuracy above 99.9% at all levels, substantially outperforming TM-score.
      <i style="font-weight: bold">c</i>&#41; the assignments of two million
      structure pairs (sequence identity &gt;70%) into four Quadrants (Q1 to Q4)
      based on the results of VSSmeasur and SPS<span class="xiabiao"
        >measur</span
      >. Q1 demonstrated the pairs of similar structure (VSSmeasur &lt; 0.5 &
      SPS<span class="xiabiao">measur</span> &lt; 0.5); Q2 presented the pairs
      having shift among protein segments (VSSmeasur &lt; 0.5 & SPS<span
        class="xiabiao"
        >measur</span
      >
      ≥ 0.5); Q4 provided the pairs with variation in secondary structures
      (VSSmeasur ≥ 0.5 & SPS<span class="xiabiao">measur</span> &lt; 0.5); Q3
      gave the pairs with both shift among segments and variation in secondary
      structure (VSSmeasur ≥ 0.5 & SPS<span class="xiabiao">measur</span> ≥
      0.5). The pie charts provided the level of agreement between
      <i>MELO</i> and TM-score in each Quadrant. In Q1, the <i>MELO</i> and
      TM-score mostly achieved the same conclusions with 0.01% disagreement.
      Notably, the vast majority of these disagreed structure pairs had their
      aligned sequences less than 40 amino acids, which were consistent with
      AF3’s observation that TM-score was not effective enough for short
      sequence. In Q2, Q3 and Q4, where <i>MELO</i> found structure changes, the
      findings of two methods were largely inconsistent, with 86.45%, 97.23% and
      91.95% pairs having distinct conclusion, respectively. In other words, our
      <i>MELO</i> identified 12,562 SC<i>in</i>sv protein pairs from PDB, while
      TM-score found 1,411. <i style="font-weight: bold">d</i>&#41; a
      representative pair of proteins in Q2 (Borrelia burgdorferi OspA before
      and after the replacement of two β-hairpin sequences with Gly-Gly and
      shortening of one β-hairpin). Shifts among protein segments were captured
      by <i>MELO</i> (VSSmeasur = 0.13, SPS<span class="xiabiao">measur</span> =
      0.63), while both TM-score and LDDT failed to identify these structural
      changes. <i style="font-weight: bold">e</i>&#41; a representative protein
      pair in Q3 (intestinal fatty acid-binding protein and its helix-less
      variant). Both the variations in secondary structures and shifts among
      protein segments were successfully identified by <i>MELO</i> (VSSmeasur =
      0.66 & SPS<span class="xiabiao">measur</span> = 0.65), but not found by
      TM-score and RMSD. <i style="font-weight: bold">f</i>&#41; a
      representative protein pair in Q4 (change of some ordered secondary
      structures to disordered ones in SARS-CoV-2 spike protein induced by
      multi-point mutations). Such changes were successfully captured by
      <i>MELO</i>
      (VSSmeasur = 0.56 & SPS<span class="xiabiao">measur</span> = 0.35), but
      did not discovered by other existing methods.
    </div>
    <div class="yyy" v-else-if="figureIndex == '4'">
      Analyses on the conformational transition of two transporters (ABCB1 and
      ABCG2) between inward-facing state and outward-facing one.
      <i style="font-weight: bold">a</i>&#41; schematic representation of
      ABCB1’s structure. This structure contained two chains (Chain A and Chain
      B), and each chain consisted of a transmembrane domain (TMD) and a
      nucleotide-binding domain (NBD). As provided, the 1st-3rd α-helices,
      4th-5th α-helices and 6th α-helix-NBD1 in the Chain A were grouped to A1,
      A2 and A3, respectively, and the 7th-9th α-helices, 10th-11th α-helices
      and 12th α-helix-NBD2 in the Chain B were assigned into B1, B2 and B3,
      respectively. <i style="font-weight: bold">b</i>&#41; schematic
      illustration of ABCG2’s structure. This structure contained two chains
      (Chain A and Chain B), and each chain consisted of one TMD and one NBD.
      <i style="font-weight: bold">c</i>&#41; schematic illustration of ABCB1’s
      inward-facing and outward-facing states. The TMDs in Chain A and Chain B
      of ABCB1 interwove with each other to form two V-shaped structures.
      <i style="font-weight: bold">d</i>&#41; schematic representation of
      ABCG2’s inward-facing and outward-facing states. The TMDs in Chain A and
      Chain B of ABCG2 were largely independent, with no interweaving between
      two chains. <i style="font-weight: bold">e</i>&#41; assessing the
      structure change between the inward-facing state (IF, PDB:6A6N) and the
      outward-facing one (OF, PDB:6A6M) of ABCB1 using different scoring
      methods. Substantial shifts among six structure segments (A1, A2, A3, B1,
      B2, and B3) were discovered by <i>MELO</i> (VSSmeasur = 0.27 & SPS<span
        class="xiabiao"
        >measur</span
      >
      = 0.58; being in the Q2 of Figure 3c), and one out of three existing
      methods (RMSD) identified the structure change. The PLOT<span
        class="shangbiao"
        >SPS</span
      >of <i>MELO</i> was depicted, which identified nine pairs of protein
      segments of obvious structure shifts (such as A1 vs B3, A3 vs B3, and B2
      vs B3; largely colored in RED). If all those segment pairs were
      collectively considered, a substantial shift between two protein segments
      (A1-B2-A3 and B1-A2-B3) could be identified by <i>MELO</i>, which aligned
      well with the schematic illustration in Figure 4c.
      <i style="font-weight: bold">f</i>&#41; assessing the structure change
      between the inward-facing state (IF, PDB:6VXH) and outward-facing one (OF,
      PDB:6HZM) of ABCG2 using different methods. Extensive shifts between Chain
      A and Chain B were discovered by ME<i>MELO</i>LO (VSSmeasur = 0.37 &
      SPS<span class="xiabiao">measur</span> = 0.57; being in the Q2 of Figure
      3c), and two out of three methods (LDDT and RMSD) identified the structure
      change. The PLOT<span class="shangbiao">SPS</span>was also depicted, which
      captured one segment pair of obvious structure shifts (Chain A vs Chain B;
      largely colored in RED), which described that our <i>MELO</i> could
      capture the substantial shift between chains. Such results aligned well
      with the schematic diagrams highlighted in Figure 4d. All in all, based on
      those analyses above, <i>MELO</i> was found capable of not only accurately
      identifying the variations between conformational states but also
      differentiating the mechanisms underlying the structure changes of two
      transporters.
    </div>
    <div class="yyy" v-else-if="figureIndex == '5'">
      Locating the structure alterations of ABCB1 between the inward-facing and
      outward-facing conformations. (<i style="font-weight: bold">a</i>) the
      structure alterations captured by residue-wise LDDT, RMSD, and SPS<span
        class="xiabiao"
        >measur</span
      >. Clear structure changes in the substrate entrance region (at the bottom
      of ABCB1) & the transmembrane region were discovered by residue-wise
      SPS<span class="xiabiao">measur</span> and residue-wise RMSD (highlighted
      by gradual RED shading; the redder it is, the greater the change); the
      residue-wise LDDT could also find certain level of changes in the
      substrate entrance region, but highlighted changes at the top of ABCB1
      instead of its transmembrane regions. (<i style="font-weight: bold">b</i>)
      the structure alterations in the segment A2 of ABCB1 discovered by
      residue-wise LDDT, RMSD, and SPS<span class="xiabiao">measur</span>. (<i
        style="font-weight: bold"
        >c</i
      >) he PLOT<span class="shangbiao">SPS</span> in MELO that captures the
      inter-chain & inter-segment changes. The structure change of segment A2
      relative to five other segments (A1, A3, B1, B2 and B3; RED dashed box)
      were visualized, the conformation alterations of which were further
      depicted in (<i style="font-weight: bold">d</i>) A2 relative to A1, (<i
        style="font-weight: bold"
        >e</i
      >) A2 relative to A3, (<i style="font-weight: bold">f</i>) A2 relative to
      B1, (<i style="font-weight: bold">g</i>) A2 relative to B2 and (<i
        style="font-weight: bold"
        >h</i
      >) A2 relative to B3. One inter-chain change (A2 relative to B2), two
      inner-chain changes (A2 relative to A1; A2 relative to A3), and two
      non-significant changes (A2 relative to B1; A2 relative to B1) were
      identified.
    </div>
    <div class="yyy" v-else-if="figureIndex == '6'">
      Analyses on the structure changes of CRABPⅡ protein induced by mutation or
      ligand binding. Apart from the most common conformations (39 conformations
      of identical sequences deposited by different research groups),
      holo-CRABPⅡ (HC), which bound retinoic acids, two conformations were
      collected from PDB: apo-CRABPⅡ (AC) without retinoic acid and mutant
      CRABPⅡ (MC) with the R35D and K36D mutation.
      <i style="font-weight: bold">a</i>&#41; evaluating outcome for three
      groups of structure pairs (HC vs HC, MC vs HC, and AC vs HC) based on
      VSSmeasur (x-axis) and SPS<span class="xiabiao">measur</span> (y-axis) of
      <i>MELO</i>. Great shifts among protein segments between MC and HC were
      captured by <i>MELO</i> (0.21 &lt; VSSmeasur &lt; 0.30 & 0.58 &lt;
      SPS<span class="xiabiao">measur</span> &lt; 0.61; being in Q2 of Figure
      3c). Both the variations in secondary structures and shifts among protein
      segments between AC and HC were discovered by <i>MELO</i> (0.50 &lt;
      VSSmeasur &lt; 0.53 & 0.55 &lt; SPS<span class="xiabiao">measur</span>
      &lt; 0.59; being in Q3 of Figure 3c). No significant change in structure
      was observed among 39 conformations of HC by <i>MELO</i> (0.01 &lt;
      VSSmeasur &lt; 0.21 & 0.03 &lt; SPS<span class="xiabiao">measur</span>
      &lt; 0.26; being in Q1 of Figure 3c), which illustrated the stability and
      accuracy of <i>MELO</i> in differentiating changed structure and the
      unchanged one. <i style="font-weight: bold">b</i>&#41; violin plots for
      comparing three methods by analyzing their abilities to discern the
      structure change among three conformations of CRABPⅡ. <i>MELO</i> was able
      to identify the extensive shift among protein segments between MC and HC,
      and reveal the variations in secondary structure and shifts among protein
      segments between AC and HC. TM-score could not identify structure change
      not only between MC and HC but also between AC and HC, and LDDT was not
      useful enough to identify the corresponding structure changes.
      <i style="font-weight: bold">c</i>&#41; assessing structure change between
      mutant CRABPⅡ (MC, PDB:7OXW) and holo-CRABPⅡ (HC, PDB:6HKR) based on
      different methods. Only <i>MELO</i> could capture the shifts among
      segments (VSSmeasur = 0.25 & SPS<span class="xiabiao">measur</span> =
      0.59; being in the Q2 of Figure 3c).
      <i style="font-weight: bold">d</i>&#41; evaluating the structure change
      between apo-CRABPⅡ (AC, PDB:1BLR) and holo-CRABPⅡ (HC, PDB:6HKR) using
      different methods. Only <i>MELO</i> could detect the variations in
      secondary structure and shifts among protein segments (VSSmeasur = 0.53 &
      SPS<span class="xiabiao">measur</span> = 0.58; being in the Q3 of Figure
      3c).
    </div>
    <div class="yyy" v-else-if="figureIndex == '7'">
      Locating the structure alteration of CRABPⅡ between AC and HC induced by
      ligand binding.
      <i style="font-weight: bold">a</i>&#41; the PLOT<span class="shangbiao"
        >VSS</span
      >
      generated by <i>MELO</i> for locating the variations in secondary
      structure. Three regions of obvious alterations were highlighted, which
      included the second helix (purple box), βD loop (brown box), and βJ loop
      (umber box). T: β-turn; E: β-strand; B: β-bridge; H: α-helix; I: Π-helix;
      G: 310-helix; P: κ-helix. <i style="font-weight: bold">b</i>&#41; the
      PLOT<span class="shangbiao">SPS</span> generated by <i>MELO</i> for
      locating the shifts among protein segments with darker color showing
      regions of significant displacements. The second helix (purple box) and
      the βE-βF loop (umber box) were captured by <i>MELO</i> as key regions of
      segmental shifts. <i style="font-weight: bold">c</i>&#41; structural
      superimpositions of apo-CRABPII (AC, PDB:1BLR) and holo-CRABPⅡ (HC,
      PDB:6HKR), providing main variations in secondary structures &#40;such as
      the second helix (purple box), the βD loop (brown box) & the βJ loop
      (umber box). <i style="font-weight: bold">d</i>&#41; shift was discovered
      for the second helix. <i style="font-weight: bold">e</i>&#41; shift was
      identified for the βE-βF. All in all, the <i>MELO</i> was found capable of
      identifying not only the variation in secondary structure but also the
      shift among protein segments in the studied protein of
      <i>cellular retinoic acid-binding protein 2</i>.
    </div>
    <div class="yyy" v-else>
      Four unique characteristics of our web-server. It worked via
      <i style="font-weight: bold">a</i>&#41; realizing the customized
      assessment by allowing the users to upload their own structures,
      <i style="font-weight: bold">b</i>&#41; providing a downloadable local
      version for enabling high-throughput analysis and protecting data
      security, <i style="font-weight: bold">c</i>&#41; offering over 10,000
      structure changes induced by small sequence alteration as an accessible
      database, and <i style="font-weight: bold">d</i>&#41; giving in-depth
      descriptions of the measurement and location for all SC<i>in</i>svs. From
      the function perspective, this server enabled the measurement & location
      of any new pairs of protein structures; its local version was extremely
      efficient in high-throughput analysis and able to ensure user data
      security. From the data perspective, the affiliated database provided over
      two million protein pairs together with the assessments of their structure
      change; the in-depth description of the measurement and location for all
      SC<i>in</i>svs were provided.
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    figureIndex: {
      type: String,
      required: true,
    },
  },
};
</script>


